import store from "@/store";
import { postDataToNativeApp, isString } from "../utils/helper";

const routeNameWithoutAuth = ["terms", "login", "signup"];
export const HOME_ROUTE_NAME = "home";
export const FOREVER_LOADING_ROUTE_NAME = "ForeverLoading";

const storeSessionKeyAndUserID = (to, from, next) => {
  console.log(from, to);
  if (routeNameWithoutAuth.includes(to.name)) {
    next();
    return;
  }
  if (window.userInfoGPS) {
    if (to.name === FOREVER_LOADING_ROUTE_NAME) {
      next({ name: "404" });
      return;
    }
    // if (["home", "inquiries"].includes(to.name)) {
    if (
      store.state.userID &&
      store.state.sessionKey &&
      store.state.lat &&
      store.state.long
    ) {
      next();
      return;
    }
    const nativeData = window.userInfoGPS;
    let res = {};
    if (nativeData) {
      if (isString(nativeData)) {
        res = JSON.parse(nativeData);
      } else {
        res = nativeData;
      }
    } else {
      next({ name: "404" });
      return;
    }

    if (res.userID && res.sessionKey && res.lat && res.long) {
      store.commit("storeSessionKeyAndUserID", {
        userID: res.userID,
        sessionKey: res.sessionKey,
      });
      store.commit("storeLatAndLong", {
        lat: res.lat,
        long: res.long,
      });
      next();
      return;
    }
    // } else {
    //   if (store.state.userID && store.state.sessionKey) {
    //     next();
    //     return;
    //   }
    //   const nativeData = window.userInfo || window.userInfoGPS;
    //   let res = {};
    //   if (isString(nativeData)) {
    //     res = JSON.parse(nativeData);
    //   } else {
    //     res = nativeData;
    //   }
    //   if (res.userID && res.sessionKey) {
    //     store.commit("storeSessionKeyAndUserID", {
    //       userID: res.userID,
    //       sessionKey: res.sessionKey,
    //     });
    //     next();
    //     return;
    //   }
    // }
  } else {
    return checkRouteWithoutUserInfoGPS(to, from, next);
  }
};

const checkRouteWithoutUserInfoGPS = (to, from, next) => {
  const isNavigatingToHomeWithManualQuery =
    to.name === HOME_ROUTE_NAME && to.query.manual === "true";
  if (isNavigatingToHomeWithManualQuery) {
    return next();
  }
  next({ name: FOREVER_LOADING_ROUTE_NAME });
  return;
};

const authAdmin = (to, from, next) => {
  console.log(to, from);
  if (
    localStorage.getItem("adminUserID") &&
    localStorage.getItem("adminSessionKey")
  ) {
    store.commit("storeSessionKeyAndUserID", {
      userID: localStorage.getItem("adminUserID"),
      sessionKey: localStorage.getItem("adminSessionKey"),
    });
    next();
    return;
  } else if (store.state.userID && store.state.sessionKey) {
    next();
    return;
  }
  next({ name: "admin.login" });
  return;
};

const authUser = (to, from, next) => {
  console.log(to, from);
  if (localStorage.getItem("userID") && localStorage.getItem("sessionKey")) {
    store.commit("storeSessionKeyAndUserID", {
      userID: localStorage.getItem("userID"),
      sessionKey: localStorage.getItem("sessionKey"),
    });
    next();
    return;
  } else if (store.state.userID && store.state.sessionKey) {
    next();
    return;
  }
  next({ name: "user.login" });
  return;
};

const beforeSignUp = (to, from, next) => {
  console.log(from, to);
  if (from.name === null || from.name !== "login") {
    next({ name: "login" });
    return;
  }
  next();
  return;
};

const beforeLogin = (to, from, next) => {
  console.log(from, to);
  if (
    (from.name === null || from.name !== "terms") &&
    !store.state.agreedTerms
  ) {
    next({ name: "terms" });
    return;
  }
  next();
  return;
};

export default [
  {
    path: "/",
    name: FOREVER_LOADING_ROUTE_NAME,
    component: () => import("@/pages/loading/ForeverLoading.vue"),
  },
  {
    path: "",
    name: "DefaultLayout",
    component: () => import("@/layouts/DefaultLayout.vue"),
    beforeEnter: storeSessionKeyAndUserID,
    children: [
      {
        path: "/home",
        name: HOME_ROUTE_NAME,
        component: () => import("@/pages/home/index.vue"),
      },
    ],
  },
  {
    path: "",
    name: "EmptyLayout",
    component: () => import("@/layouts/EmptyLayout.vue"),
    children: [
      {
        path: "/signup",
        name: "signup",
        beforeEnter: beforeSignUp,
        component: () => import("@/pages/signup/index.vue"),
      },
      {
        path: "/admin/login",
        name: "admin.login",
        component: () => import("@/pages/admin/login/index.vue"),
      },
      {
        path: "/examinees/login",
        name: "user.login",
        component: () => import("@/pages/examinees/login/index.vue"),
      },
    ],
  },
  {
    path: "",
    name: "DetailLayout",
    component: () => import("@/layouts/DetailLayout.vue"),
    beforeEnter: storeSessionKeyAndUserID,
    children: [
      {
        path: "/notices",
        name: "notices.index",
        meta: { title: "お知らせ一覧" },
        component: () => import("@/pages/notices/index.vue"),
      },
      {
        path: "/unsubcribe",
        name: "unsubcribe",
        meta: { title: "アプリへの参加解除" },
        component: () => import("@/pages/unsubcribe/index.vue"),
      },
      {
        path: "/terms",
        name: "terms",
        meta: { title: "アプリへの参加許諾" },
        component: () => import("@/pages/terms/index.vue"),
      },
      {
        path: "/finc/invitatio_code",
        name: "finc.invitatio_code",
        meta: { title: "招待コード", noBackIcon: true },
        component: () => import("@/pages/finc/invitatio_code/index.vue"),
      },
      {
        path: "/finc/user_register",
        name: "finc.user_register",
        meta: { title: "ユーザ情報登録" },
        component: () => import("@/pages/finc/user_register/index.vue"),
      },
      {
        path: "/login",
        name: "login",
        meta: { title: "ログイン" },
        beforeEnter: beforeLogin,
        component: () => import("@/pages/login/index.vue"),
      },
      {
        path: "/physical-program",
        name: "physical-program",
        meta: {
          title: "体力づくりプログラム",
        },
        component: () => import("@/pages/physical-program/index.vue"),
      },
      {
        path: "/knee-pains/edit",
        name: "knee-pains.edit",
        meta: {
          title: "膝の痛み",
        },
        component: () => import("@/pages/knee-pains/edit.vue"),
      },
      {
        path: "/knee-pains",
        name: "knee-pains.index",
        meta: {
          title: "膝の痛み",
          updateRouterName: "knee-pains.edit",
          back: "home",
        },
        component: () => import("@/pages/knee-pains/index.vue"),
      },
      {
        path: "/walks",
        name: "walks.index",
        meta: {
          title: "步行状態",
        },
        component: () => import("@/pages/walks/index.vue"),
      },
      {
        path: "/heartbeats",
        name: "heartbeats.index",
        meta: {
          title: "脈拍数",
        },
        component: () => import("@/pages/heartbeats/index.vue"),
      },
      {
        path: "/sleeps",
        name: "sleeps.index",
        meta: {
          title: "睡眠の状態",
        },
        component: () => import("@/pages/sleeps/index.vue"),
      },
      {
        path: "/moods",
        name: "moods.index",
        meta: {
          title: "気分",
          updateRouterName: "moods.edit",
          back: "home",
        },
        component: () => import("@/pages/moods/index.vue"),
      },
      {
        path: "/foods",
        name: "foods.index",
        meta: {
          title: "食品カレンダー",
          albumRouterName: "foods.album.index",
          back: "home",
        },
        component: () => import("@/pages/foods/index.vue"),
      },
      {
        path: "/foods/create",
        name: "foods.create",
        meta: {
          title: "食品群登録",
        },
        component: () => import("@/pages/foods/create/index.vue"),
      },
      {
        path: "/foods/album",
        name: "foods.album.index",
        meta: {
          title: "食事アルバム",
          back: "foods.index",
        },
        component: () => import("@/pages/foods/album/index.vue"),
      },
      {
        path: "/moods/edit",
        name: "moods.edit",
        meta: {
          title: "気分",
        },
        component: () => import("@/pages/moods/edit.vue"),
      },
      {
        path: "/mypage",
        name: "mypage",
        meta: { title: "ユーザ情報確認" },
        component: () => import("@/pages/mypage/index.vue"),
      },
      {
        path: "/inquiries",
        name: "inquiries",
        meta: { title: "お問い合わせ", noBackIcon: true },
        component: () => import("@/pages/inquiries/index.vue"),
      },
      {
        path: "/notices/:id",
        name: "notices.show",
        meta: { title: "お知らせ詳細" },
        component: () => import("@/pages/notices/show.vue"),
        props: true,
      },
      {
        path: "/devices/silmee",
        name: "devices.silmee.index",
        meta: {
          title: "Silmee登録",
          onBack: () => postDataToNativeApp("viewDevice"),
          // back: "home",
        },
        component: () => import("@/pages/devices/silmee/index.vue"),
      },
      {
        path: "/devices/silmee/:id",
        name: "devices.silmee.show",
        meta: { title: "Silmee情報" },
        component: () => import("@/pages/devices/silmee/show.vue"),
        props: true,
      },
      {
        path: "/talks",
        name: "talks.index",
        meta: {
          title: "会話状態",
        },
        component: () => import("@/pages/talks/index.vue"),
      },
      {
        path: "/skin-temps",
        name: "skin-temps.index",
        meta: {
          title: "皮膚温度",
        },
        component: () => import("@/pages/skin-temps/index.vue"),
      },
      {
        path: "/speed",
        name: "speed.index",
        meta: { title: "歩行速度" },
        component: () => import("@/pages/speed/index.vue"),
      },
      {
        path: "/pitch",
        name: "pitch.index",
        meta: { title: "歩行リズム" },
        component: () => import("@/pages/pitch/index.vue"),
      },
      {
        path: "/metsh",
        name: "stride.index",
        meta: { title: "歩幅" },
        component: () => import("@/pages/metsh/index.vue"),
      },
      {
        path: "/kcal",
        name: "kcal.index",
        meta: { title: "消費カロリー" },
        component: () => import("@/pages/kcal/index.vue"),
      },
      {
        path: "/user_auth",
        name: "user-auth.index",
        meta: { title: "WEBログイン情報" },
        component: () => import("@/pages/user-auth/index.vue"),
      },
      {
        path: "/last-month-life-pattern",
        name: "last-month-life-pattern.index",
        meta: { title: "1ヶ月間の生活パターン" },
        component: () => import("@/pages/last-month-life-pattern/index.vue"),
      },
      {
        path: "/overall-health",
        name: "overall-health.index",
        meta: { title: "全体的な健康状態", back: "questionnaire.index" },
        component: () => import("@/pages/overall-health/index.vue"),
      },
      {
        path: "/food-calendar-month",
        name: "/food-calendar-month.index",
        meta: { title: "食品月間カレンダー" },
        component: () => import("@/pages/food-calendar-month/index.vue"),
      },
      {
        path: "/questionnaire",
        name: "questionnaire.index",
        meta: { title: "調査票", back: "home" },
        component: () => import("@/pages/questionnaire/index.vue"),
      },
      {
        path: "/frail-calendar",
        name: "frail-calendar.index",
        meta: { title: "フレイルカレンダー" },
        component: () => import("@/pages/frail-calendar/index.vue"),
      },
      {
        path: "/frail-chart",
        name: "frail-chart.index",
        meta: {
          title: "フレイルチャート",
          goToFrailCalendar: true,
        },
        component: () => import("@/pages/frail-chart/index.vue"),
      },
      {
        path: "/materials-and-method",
        name: "materials-and-method.index",
        meta: {
          title: "材料と作り方",
        },
        component: () => import("@/pages//materials-and-method/index.vue"),
      },
    ],
  },
  {
    path: "",
    name: "AdminLayout",
    component: () => import("@/layouts/AdminLayout.vue"),
    beforeEnter: authAdmin,
    children: [
      {
        path: "/admin/notices",
        name: "admin.notices",
        component: () => import("@/pages/admin/notices/index.vue"),
      },
      {
        path: "/admin/top",
        name: "admin.top",
        meta: {
          noBackIcon: true,
        },
        component: () => import("@/pages/admin/top/index.vue"),
      },
      {
        path: "/admin/password/edit",
        name: "admin.password.edit",
        component: () => import("@/pages/admin/password/edit.vue"),
      },
      {
        path: "/admin/examinees/new",
        name: "admin.examinees.new",
        component: () => import("@/pages/admin/examinees/new.vue"),
      },
      {
        path: "/admin/examinees/:id/edit",
        name: "admin.examinees.edit",
        component: () => import("@/pages/admin/examinees/edit.vue"),
        props: true,
      },
      {
        path: "/admin/examinees",
        name: "admin.examinees.index",
        component: () => import("@/pages/admin/examinees/index.vue"),
      },
      {
        path: "/admin/examinees/:id",
        name: "admin.examinees.show",
        component: () => import("@/pages/admin/examinees/show.vue"),
      },
      {
        path: "/admin/examinees/:id/walks",
        name: "admin.examinees.walks",
        component: () => import("@/pages/admin/examinees/walks/index.vue"),
        props: true,
      },
      {
        path: "/admin/examinees/:id/sleeps",
        name: "admin.examinees.sleeps",
        component: () => import("@/pages/admin/examinees/sleeps/index.vue"),
        props: true,
      },
      {
        path: "/admin/examinees/:id/hrs",
        name: "admin.examinees.hrs",
        component: () => import("@/pages/admin/examinees/hrs/index.vue"),
        props: true,
      },
      {
        path: "/admin/examinees/:id/skin-temps",
        name: "admin.examinees.skin-temps",
        component: () => import("@/pages/admin/examinees/skin-temps/index.vue"),
        props: true,
      },
      {
        path: "/admin/examinees/:id/talks",
        name: "admin.examinees.talks",
        component: () => import("@/pages/admin/examinees/talks/index.vue"),
        props: true,
      },
      {
        path: "/admin/examinees/:id/kcals",
        name: "admin.examinees.kcals",
        component: () => import("@/pages/admin/examinees/kcals/index.vue"),
        props: true,
      },
      {
        path: "/admin/examinees/:id/speed",
        name: "admin.examinees.speed",
        component: () => import("@/pages/admin/examinees/speed/index.vue"),
        props: true,
      },
      {
        path: "/admin/examinees/:id/metsh",
        name: "admin.examinees.metsh",
        component: () => import("@/pages/admin/examinees/metsh/index.vue"),
        props: true,
      },
      {
        path: "/admin/examinees/:id/pitch",
        name: "admin.examinees.pitch",
        component: () => import("@/pages/admin/examinees/pitch/index.vue"),
        props: true,
      },
      {
        path: "/admin/pdfs",
        name: "admin.pdfs.index",
        component: () => import("@/pages/admin/pdfs/index.vue"),
        props: true,
      },
      {
        path: "/admin/pdfs/download/:month",
        name: "admin.pdfs.download",
        component: () => import("@/pages/admin/pdfs/download.vue"),
        props: true,
      },
    ],
  },
  {
    path: "",
    name: "UserLayout",
    component: () => import("@/layouts/UserLayout.vue"),
    beforeEnter: authUser,
    children: [
      {
        path: "/examinees/:id",
        name: "user.home",
        component: () => import("@/pages/examinees/home/index.vue"),
      },
      {
        path: "/examinees/:id/walks",
        name: "user.examinees.walks",
        component: () => import("@/pages/examinees/walks/index.vue"),
        props: true,
      },
      {
        path: "/examinees/:id/sleeps",
        name: "user.examinees.sleeps",
        component: () => import("@/pages/examinees/sleeps/index.vue"),
        props: true,
      },
      {
        path: "/examinees/:id/hrs",
        name: "user.examinees.hrs",
        component: () => import("@/pages/examinees/heartbeats/index.vue"),
        props: true,
      },
      {
        path: "/examinees/:id/skin-temps",
        name: "user.examinees.skin-temps",
        component: () => import("@/pages/examinees/skin-temps/index.vue"),
        props: true,
      },
      {
        path: "/examinees/:id/talks",
        name: "user.examinees.talks",
        component: () => import("@/pages/examinees/talks/index.vue"),
        props: true,
      },
      {
        path: "/examinees/:id/kcals",
        name: "user.examinees.kcals",
        component: () => import("@/pages/examinees/kcals/index.vue"),
        props: true,
      },
      {
        path: "/examinees/:id/speed",
        name: "user.examinees.speed",
        component: () => import("@/pages/examinees/speed/index.vue"),
        props: true,
      },
      {
        path: "/examinees/:id/metsh",
        name: "user.examinees.metsh",
        component: () => import("@/pages/examinees/metsh/index.vue"),
        props: true,
      },
      {
        path: "/examinees/:id/pitch",
        name: "user.examinees.pitch",
        component: () => import("@/pages/examinees/pitch/index.vue"),
        props: true,
      },
      {
        path: "/examinees/:id/silmee",
        name: "user.examinees.silmee",
        component: () => import("@/pages/examinees/silmee/index.vue"),
        props: true,
      },
      {
        path: "/examinees/:id/silmee/:silmee_id",
        name: "user.examinees.silmee.show",
        component: () => import("@/pages/examinees/silmee/show.vue"),
        props: true,
      },
      {
        path: "/examinees/:id/walkx",
        name: "user.examinees.walkx",
        component: () => import("@/pages/examinees/walkx/index.vue"),
        props: true,
      },
      {
        path: "/examinees/:id/walkx/:walk_id",
        name: "user.examinees.walkx.show",
        component: () => import("@/pages/examinees/walkx/show.vue"),
        props: true,
      },
      {
        path: "/examinees/:id/mypage",
        name: "user.examinees.mypage",
        component: () => import("@/pages/examinees/mypage/index.vue"),
        props: true,
      },
    ],
  },
  {
    // will match everything
    path: "*",
    name: "404",
    component: () => import("@/pages/error/404.vue"),
  },
];
